import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../States/AppContext";
import { Link } from "react-router-dom";

//components
import { SettingAlertAudioOff, SettingAlertSync } from "./SettingAlert";
import AlarmBox from "./Alarms/AlarmBox";

// styles
import {
  TopBarBattery,
  TopBarContainer,
  TopBarIconContainer,
  TopBarIconPng,
  TopBarMonitor,
  TopBarTime,
  TopBarIconWrapper,
} from "./TopBar.elements";

// icons & images
import { AiFillLock } from "react-icons/ai";
import { FaBell } from "react-icons/fa";
import batteryicon from "../../img/icons/battery.png";
import monitor from "../../img/icons/monitor2.png";
import noalarm from "../../img/icons/noalarm4.png";

const TopBar = () => {
  const { state, setState } = useContext(AppContext);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); 

    return () => clearInterval(interval); 
  }, []);

  const hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();

  const formattedTime = `${
    hours === 0 ? 12 : hours > 12 ? hours - 12 : hours
  }:${minutes < 10 ? "0" : ""}${minutes}`;


  useEffect(() => {
    if (state.settingAlertAudio === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          settingAlertAudio: false,
          settingAlertSync: true,
        }));
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [state.settingAlertAudio]);

  useEffect(() => {
    if (state.settingAlertSync === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({ ...prevState, settingAlertSync: false }));
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [state.settingAlertSync]);





  return (
    <TopBarContainer>
      <TopBarIconContainer>

        {state.initiateAlarms ? (
          <AlarmBox></AlarmBox>
        ) : !state.piicConnected ? (
          <AlarmBox></AlarmBox>
        ) :
        (
          <TopBarTime>{formattedTime}</TopBarTime>
        )}

      
        <Link to="/localaudio">
          {state.telemetry ? (
            <TopBarIconPng src={noalarm} />
          ) : (
            <TopBarIconWrapper>
              <FaBell />{" "}
            </TopBarIconWrapper>
          )}
        </Link>
      </TopBarIconContainer>
  
      {state.standBy && <SettingAlertAudioOff />}
      {state.settingAlertAudio && <SettingAlertAudioOff />}
      {state.settingAlertSync && <SettingAlertSync />}



      <TopBarIconContainer>
     

        {state.isLocked ? (
          <AiFillLock style={{ color: "red" }} />
        ) : state.isLockEnterPw ? (
          <AiFillLock style={{ color: "red" }} />
        ) : (
          <div></div>
        )}
     
        <Link
          to="/settings/devicestatus"
          style={{ display: "flex", alignItems: "center" }}
        >
          {!state.piicConnected ? (
            <div
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              <TopBarMonitor src={monitor} />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%) rotate(45deg)",
                  width: "140%",
                  height: "2px",
                  backgroundColor: "#caceca",
                }}
              ></div>
            </div>
          ) : (
            <TopBarMonitor src={monitor} />
          )}

          <TopBarBattery src={batteryicon} />
        </Link>
      </TopBarIconContainer>
    </TopBarContainer>
  );
};

export default TopBar;
